import { Flex, type FlexProps } from '@/new_src/view/components/Flex';

import { useTheme } from 'styled-components';

export type DividerVariant = 'light' | 'medium' | 'dark' | 'transparent-light' | 'transparent-dark';

type DividerProps = Pick<FlexProps, 'm' | 'mt' | 'mb' | 'ml' | 'mr' | 'mx' | 'my'> & {
  variant?: DividerVariant;
};

export const Divider = ({ variant = 'medium', ...margins }: DividerProps) => {
  const theme = useTheme();

  const variantColors: Record<DividerVariant, FlexProps['bg']> = {
    light: 'gray.2',
    medium: 'gray.3',
    dark: 'gray.4',
    'transparent-light': theme.createRGBAWithHex(theme.mantineColors.gray[8], 0.05),
    'transparent-dark': theme.createRGBAWithHex(theme.mantineColors.gray[8], 0.1),
  };

  return <Flex h={1} shrink={0} bg={variantColors[variant]} {...margins} />;
};
